import axios from '../services/api'
type ReportStatus = 'CERTAIN' | 'UNCERTAIN' | 'UNKNOWN';

export type ExhibitionReportProps = {
  audio_duration: string;
  audio_key: string;
  created_date: string;
  extimated_start_datetime: string;
  extimated_stop_datetime: string;
  id: number;
  match_source: string;
  modified_date: string;
  status: ReportStatus;
}

export type GetExhibitionReportType = {
  source: string, 
  dateFrom: string, 
  dateTo: string, 
  filter?: Array<ReportStatus>
}

export type ClipReportRefShape = {
    source?: string;
    content?: string;
    className?: string;
    audio_duration: string;
    audio_key: string;
    created_date: string;
    extimated_start_datetime: string;
    extimated_stop_datetime: string;
    id: number;
    match_source: string;
    modified_date: string;
    status: ReportStatus;
}

export type CustomTimelineItem = {
    id: number,
    audio_key: string,
    type: string,
    content: string | HTMLElement,
    start: Date,
    end: Date,
    editable: CustomEditableTimelineItem,
    className: string,
    selectable: boolean,
}

export type CustomEditableTimelineItem = {
    updateTime: boolean,
}

export type DispatcherCreativeItem = {
    id: number,
    metadata: DispatcherCreativeMetadata,
    external_id: number
}

export type DispatcherCreativeMetadata = {
    title: string,
    advertiser: string,
    duration: number,
}

export const generateTimelineCriticalItems = (criticalStart: number, criticalEnd: number) => {
    return [
        {
            id: 1, 
            audio_key: 0,
            type: 'range',
            content:'', 
            start: new Date('2023-11-20 00:00:00'), 
            end: new Date(criticalStart), 
            editable: {
                updateTime: false
            }, 
            className: 'proibido',
            selectable: false,
        },
        {
            id: 2, 
            audio_key: 0,
            type: 'range',
            content:'', 
            start: new Date(criticalEnd), 
            end: new Date().getTime() + 86_400_000, 
            editable: {
                updateTime: false
            }, 
            className: 'proibido',
            selectable: false,
        }
]
}
export const generateTimelineRecognitionItems = (clips: ExhibitionReportProps[]) => {
    const certainList = clips.filter(clip => clip.status === "CERTAIN");

    return certainList.map(clip => {
        const start = new Date(clip.extimated_start_datetime);
        const end = new Date(clip.extimated_stop_datetime);
        
        return {
            id: clip.id, 
            audio_key: clip.audio_key,
            type: 'range',
            content: "", 
            start: start, 
            end: end,
            editable: {
                updateTime: false
            }, 
            className: `recognition-area`,
            selectable: true,
        }
    })
}

export const generateCreativeListByRecognitions = async (recognitions: CustomTimelineItem[]) => {
    const distinctAudioKeyList = Array.from(new Set(recognitions.map(r => ({
        audio_key: r.audio_key
    }))));

    let creativeListByRecognitions: DispatcherCreativeItem[] = [];


    

    const fetchPromises = distinctAudioKeyList.map(audioKey=> axios.get<DispatcherCreativeItem>(`${process.env.REACT_APP_BASE_URL}/dispatcher/creatives/external_id/${audioKey.audio_key}`).then((response) => {
        creativeListByRecognitions.push(response.data)
    },(error) =>{
        console.log(error);
    }));

    /*const fetchPromises = distinctAudioKeyList.map(audioKey=> axios.get<DispatcherCreativeItem>(`https://api.gravacaolinear.mediapro.com.br/dispatcher/creatives/external_id/${audioKey.audio_key}`).then((response) => {
        creativeListByRecognitions.push(response.data)
    }));*/
    await Promise.all(fetchPromises);
    
    
    
    return creativeListByRecognitions;
}